import React from 'react';
import { Box } from '@mui/material';
import { isNil as _isNil } from 'lodash';
//
import numberFormat from '../../renderers/numberFormat';

const currencyFooterRenderer =
  (key) =>
  ({ table }) => {
    const totals = table.options.meta?.totals || {};
    const value = totals[key] ?? 0;

    const formatted = numberFormat(value);

    return (
      <Box sx={{ fontWeight: 'bold', fontSize: '14px' }}>${formatted}</Box>
    );
  };

export const BALANCES_REPORT_COLUMN_DEFS = [
  {
    accessorKey: 'client',
    header: 'Client',
    enableResizing: true,
  },

  {
    accessorKey: 'ugwPublisher',
    header: 'Publisher',
    enableResizing: true,
  },

  {
    accessorKey: 'ugwPublisherEndpoint',
    header: 'Endpoint',
    enableResizing: true,
  },
  {
    accessorKey: 'clientPublisher',
    header: 'Client Publisher',
    minSize: 220,
    enableResizing: true,
  },
  {
    accessorKey: 'remainingBalance',
    header: 'Remaining Balance ($)',
    minSize: 250,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('remainingBalance'),
    enableResizing: true,
  },
  {
    accessorKey: 'actualRemainingBudget',
    header: 'Actual Remaining Balance ($)',
    minSize: 275,
    Cell: ({ cell, row: { original } }) =>
      _isNil(cell.getValue())
        ? '-'
        : `${numberFormat(cell.getValue())}${original.isClientBudgetUnlimited ? ' (∞)' : ''}`,
  },
  {
    accessorKey: 'endpointTotalTopUps',
    header: 'TopUps ($)',
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('endpointTotalTopUps'),
    enableResizing: true,
  },
  {
    accessorKey: 'spend',
    header: 'Spend ($)',
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('endpointTotalSpend'),
    enableResizing: true,
  },
  {
    accessorKey: 'payout',
    header: 'Payout ($)',
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('endpointTotalPayout'),
    enableResizing: true,
  },
  {
    accessorKey: 'discrepancy',
    header: 'Discrepancy ($)',
    minSize: 200,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('endpointTotalDiscrepancy'),
    enableResizing: true,
  },
  {
    accessorKey: 'endpointTotalPendingBalance',
    header: 'Pending Balance ($)',
    minSize: 220,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    Footer: currencyFooterRenderer('endpointTotalPendingBalance'),
    enableResizing: true,
  },
  {
    accessorKey: 'clientBalance',
    header: 'Client Balance ($)',
    minSize: 200,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    enableResizing: true,
  },
  {
    accessorKey: 'clientUnassignedBalance',
    header: 'Client Unassigned Balance ($)',
    minSize: 280,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    enableResizing: true,
  },
  {
    accessorKey: 'clientTotalTopUps',
    header: 'Client TopUps ($)',
    minSize: 200,
    Cell: ({ cell }) => numberFormat(cell.getValue()),
    enableResizing: true,
  },
];
